import ContactInformation from "./ContactInformation";
import MessageUs from "./MessageUs";

const Contact = () => {
  return (
    <>
      <div className="animate-slide-down">
        <h2 className="text-4xl font-bold mb-3 text-teal">Get in Touch</h2>
        <p className="text-gray-400 mb-8 md:mb-10 break-words">
          Have a project in mind or want to discuss potential opportunities? I'd love to hear from you. Feel free to reach out using the form or connect via social platforms.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div
          className="lg:col-span-2 animate-fade-in"
          style={{ animationDelay: "0.2s" }}
        >
          <MessageUs />
        </div>

        <div className="space-y-6">
          <ContactInformation />
        </div>
      </div>
    </>
  );
};

export default Contact;
